import React from 'react'
import { Link } from 'react-router-dom'
import Backgroundimage from '../../../assets/images/background/image-8.jpg';
import bg19 from '../../../assets/images/background/bg-19.png'
import bg20 from '../../../assets/images/background/bg-20.png'
import menuimg11 from '../../../assets/images/resource/menu-image-11.jpg'
import menuimg12 from '../../../assets/images/resource/menu-image-12.jpg'
import menuimg13 from '../../../assets/images/resource/menu-image-13.jpg'
import menuimg14 from '../../../assets/images/resource/menu-image-14.jpg'
import menuimg15 from '../../../assets/images/resource/menu-image-15.jpg'
import menuimg16 from '../../../assets/images/resource/menu-image-16.jpg'
import menuimg17 from '../../../assets/images/resource/menu-image-17.jpg'
import menuimg18 from '../../../assets/images/resource/menu-image-18.jpg'
import img8 from '../../../assets/images/background/image-8.jpg'
import badgeone from '../../../assets/images/resource/badge-2.png'



function Specialmenu() {
    return (

        <>
            <section className="special-offer-two">

                <div className="left-bg"><img src={bg20} alt="" title="" /></div>
                <div className="right-bg"><img src={bg19} alt="" title="" /></div>
                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle"><span>special offer</span></div>

                        <div className="pattern-image">
                            <img src={require('../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>เมนูแนะนำ(Best Special Menu)</h2>
                    </div>
                    <div className="row clearfix">
                        
                        <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="image"><Link to="#"><img src={menuimg11} alt="" /></Link></div>
                                <h4><Link to="#">ผัดผักบุ้งไฟแดง</Link></h4>
                                <div className="text desc">สูตรเด็ดจากทางร้าน !!!3แถม1!!!</div>
                                <div className="price">49.00฿</div>
                            </div>
                        </div>


                        <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="200ms">
                                <div className="image"><Link to="#"><img src={menuimg12} alt="" /></Link></div>
                                <h4><Link to="#">ยำถั่วพลู</Link></h4>
                                <div className="text desc">สูตรและน้ำยำจากทางร้าน</div>
                                <div className="price">149.00฿</div>
                            </div>
                        </div>


                        <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="400ms">
                                <div className="image"><Link to="#"><img src={menuimg13} alt="" /></Link></div>
                                <h4><Link to="#">เอ็นไก่ทอด</Link></h4>
                                <div className="text desc">เอ็นไก่ทอดกรอบสูตรจากทางร้าน</div>
                                <div className="price">89.00฿</div>
                            </div>
                        </div>


                        <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="600ms">
                                <div className="image"><Link to="#"><img src={menuimg14} alt="" /></Link></div>
                                <h4><Link to="#">ต้มเล้งแซ่บ</Link></h4>
                                <div className="text desc">ต้มเล้งแซ่บมีทั้งแบบถ้วยและหม้อไฟ</div>
                                <div className="price">99/159฿</div>
                            </div>
                        </div>


                        <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="image"><Link to="#"><img src={menuimg15} alt="" /></Link></div>
                                <h4><Link to="#">หมูมะนาว</Link></h4>
                                <div className="text desc">หมูมะนาวและน้ำราดรสเด็ด</div>
                                <div className="price">129.00฿</div>
                            </div>
                        </div>


                        <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="200ms">
                                <div className="image"><Link to="#"><img src={menuimg16} alt="" /></Link></div>
                                <h4><Link to="#">ไก่ทอดน้ำปลา</Link></h4>
                                <div className="text desc">ไก่ทอดน้ำปลากรอบๆเสริฟพร้อมน้ำจิ้มไก่</div>
                                <div className="price">119.00฿</div>
                            </div>
                        </div>


                        <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="400ms">
                                <div className="image"><Link to="#"><img src={menuimg17} alt="" /></Link></div>
                                <h4><Link to="#">สามชั้นทอดน้ำปลา</Link></h4>
                                <div className="text desc">สามชั้นทอดน้ำปลากรอบๆเสริฟพร้องซอสพริกและน้ําจิ้มซีฟู๊ด</div>
                                <div className="price">129.00฿</div>
                            </div>
                        </div>


                        <div className="offer-block-three col-xl-3 col-lg-4 col-md-6 col-sm-12">
                            <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="600ms">
                                <div className="image"><Link to="#"><img src={menuimg18} alt="" /></Link></div>
                                <h4><Link to="#">ถั่ว/เม็ดมะม่วงทอด</Link></h4>
                                <div className="text desc">ถั่ว/เม็ดมะม่วงทอดโรยเกลือกับแกล้มคลาสิค</div>
                                <div className="price">49/69฿</div>
                            </div>
                        </div>

                    </div>
                </div>

            </section>


            <section className="chef-selection">

                <div className="auto-container">
                    <div className="outer-container">
                        <div className="row clearfix">

                            <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                <div className="inner wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="0ms">
                                    <div className="image-layer" style={{ backgroundImage: `url(${Backgroundimage})` }}>

                                    </div>
                                    <div className="image"><img src={img8} alt="" /></div>
                                </div>
                            </div>

                            <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                <div className="inner wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="0ms">
                                    <div className="title-box">
                                        <span className="badge-icon"><img src={badgeone} alt="" title="" /></span>
                                        <div className="subtitle"><span>Special MENU</span></div>
                                        <div className="subtitle"><span>Commingsoon</span></div>
                                        <div className="pattern-image">
                                            <img src={require('../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                                        </div>

                                        <h3>เสต็กเนื้อดรายเอจ</h3>
                                        <div className="text">เสต็กเนื้อโคขุน สามารถเลือกระดับความสุขได้ตามต้องการ Rare/Medium Rare/Medium/Medium Well/Well Done</div>
                                    </div>
                                    <div className="price"><span className="old">XX.00</span> <span className="new">XX.00</span></div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </section>

        </>

    )
}

export default Specialmenu